module.exports = __webpack_public_path__ + "d7b4f72432966301363d95375268c7f5.png";